import Vue from 'vue'
import Vuex from 'vuex'
import Brands from './brands'
import Carousel from './carousel'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    'config': {
      logo: 'assets/images/logos/latercera.svg',
      title: 'La Tercera Tendencias',
      url: 'https://www.latercera.com/canal/tendencias',
      papeldigital: true,
      'papeldata': {
          url: 'https://edition.pagesuite.com/html5/reader/production/default.aspx?pubname=&pubid=33084897-397a-48cc-b3c0-3ce1ec447137',
          image: 'https://edition.pagesuite-professional.co.uk/get_image.aspx?w=300&pbid=33084897-397a-48cc-b3c0-3ce1ec447137&pnum=01&nocache=0609201815'
      },
      'navigation': [
        {
          url: 'https://www.latercera.com/',
          name: 'Inicio'
        },
        {
          url: 'https://www.latercera.com/la-tercera-pm/',
          name: 'La Tercera PM'
        },
        {
          url: 'https: //www.latercera.com/canal/pulso/',
          name: 'Pulso'
        },
        {
          url: 'https://www.latercera.com/canal/politica/',
          name: 'Política'
        },
        {
          url: 'https://www.latercera.com/canal/nacional/',
          name: 'Nacional'
        },
        {
          url: 'https://www.latercera.com/canal/mundo/',
          name: 'Mundo'
        },
        {
          url: 'https://www.latercera.com/canal/opinion/',
          name: 'Opinión'
        },
        {
          url: 'https://www.latercera.com/canal/tendencias/',
          name: 'Tendencias'
        },
        {
          url: 'https://www.latercera.com/canal/cultura/',
          name: 'Cultura'
        },
        {
          url: 'https://www.latercera.com/canal/cultura/',
          name: 'Entretención'
        },
        {
          url: 'https://www.latercera.com/canal/reportajes/',
          name: 'Reportajes'
        },
        {
          url: 'https://www.latercera.com/canal/el-deportivo/',
          name: 'El Deportivo'
        },
        {
          url: 'https://www.latercera.com/canal/la-tercera-tv/',
          name: 'La Tercera TV'
        },
        {
          url: 'http://edition.pagesuite.com/html5/reader/production/default.aspx?pubname=&pubid=33084897-397a-48cc-b3c0-3ce1ec447137',
          name: 'Edición Impresa'
        }
      ],
      'socialnetworks': [
        {
          url: 'https://twitter.com/latercera',
          icon: 'twitter', //TODO, cargar svgs dinámicamente en init
          name: 'Twitter'
        },
        {
          url: 'https://www.facebook.com/laterceracom',
          icon: 'facebook-f', //TODO, cargar svgs dinámicamente en init
          name: 'Facebook'
        },
        {
          url: 'https://flipboard.com/@latercera',
          icon: 'flipboard', //TODO, cargar svgs dinámicamente en init
          name: 'Flipboard'
        },
        {
          url: 'https://www.instagram.com/laterceracom/',
          icon: 'instagram', //TODO, cargar svgs dinámicamente en init
          name: 'Instagram'
        },
        {
          url: 'https://www.youtube.com/user/latercera',
          icon: 'youtube', //TODO, cargar svgs dinámicamente en init
          name: 'Youtube'
        }
      ],
      'brand': {
        image: 'assets/images/logo-mercadolibre.png',
        title: 'MercadoLibre'
      }
    },
    content: [{
      id: 0,
      title: 'eCommerce:',
      small: 'la revolución de la compra-venta por internet reflejada en el éxito de Mercado Libre',
      description: 'Con un total de <strong>4.000 millones de dólares</strong> en ventas online en 2017, el comercio electrónico ha logrado consolidarse en nuestro país como un atractivo y efectivo sistema de transacción. La plataforma <strong>Mercado Libre</strong>, actualmente, <strong>es el marketplace n°1 en América Latina</strong>.',
      img: 'content/banner-mas-vendidos.jpg',
      percentages: [{
          title: '270',
          small: 'millones de artículos',
          description: 'Ullamco elit voluptate ea enim dolor minim id excepteur et.'
        },
        {
          title: '1398',
          small: 'millones (usd)',
          description: 'Ipsum tempor quis ad veniam velit consectetur cillum ipsum quis aute.'
        },
        {
          title: '65%',
          small: 'más que en 2017',
          description: 'Reprehenderit consequat deserunt magna dolor cupidatat esse ullamco.'
        }
      ],
      phrases: [
        {

        }
      ],
      brands: Brands,
      carousel: Carousel,
      blocks: [
        {
          id: 0,
          content: '<p> Durante los últimos años, la aparición de nuevas tecnologías y el apogeo de las redes sociales han contribuido en generar un cambio de paradigma que no solo se refleja en importantes cambios en la comunicación, sino también ha facilitado una verdadera revolución en el proceso de compra-venta.</p><p>El comercio electrónico, conocido también como eCommerce, y que consiste en la compra y venta de productos o servicios a través de Internet, es un claro ejemplo de ello. El número de ventas online que se efectúan al año aumenta cada vez más, alcanzando un total de <strong>4.000 millones de dólares</strong>, de acuerdo a un análisis realizado por el Centro de Economía Digital de la Cámara de Comercio de Santiago(CCS), en relación al 2017.</p>',
          img: 'content/img0-01.jpg',
        },
        {
          id: 1,
          title: '¿Por qué la gente prefiere comprar por internet?',
          content: '<p>Las principales razones por las que los usuarios deciden realizar sus compras por Internet, según un estudio llevado a cabo por Mercado Libre en conjunto con GfKAdimark, en 2017, se relacionan con la rapidez y la efectividad del proceso. Mientras que un 71% de los usuarios se inclina por la opción “es cómodo, puedo comprar en cualquier lugar u hora”, un 50% destacó que “se accede a mejores precios” y un 45% enfatizó que “la compra es rápida y se ahorra tiempo”.</p><p>Al considerar las cifras mencionadas, no es extraño el éxito alcanzado por plataformas como Mercado Libre, fundada en 1999 por el empresario argentino Marcos Galperin, que actualmente figura como el séptimo marketplace del mundo y el primero en América Latina, con presencia en 19 países de la región.</p><p>Su sistema y modalidad convierten a Mercado Libre en la plataforma con la mejor experiencia de compra online, con envío gratis para todo Chile por compras superiores a $15.000 y con pago en hasta 6 cuotas sin interés con cualquier tarjeta de crédito.Cuenta, además, con 211, 9 millones de usuarios registrados; 10 millones de vendedores; 33, 7 millones de compradores activos; y 4000 búsquedas por segundo que generan, en promedio, 9 compras por segundo, además de un récord de un millón de ítems vendidos en un día.</p>',
          img: 'content/img0-01.jpg',
          laterales: [
            {
              'title': '71%',
              'content': 'Es cómodo, puedo comprar en cualquier lugar u hora'
            },
            {
              'title': '50%',
              'content': 'Se accede a mejores precios'
            },
            {
              'title': '45%',
              'content': 'la compra es rápida y se ahorra tiempo'
            },
          ]
        },
        {
          id: 2,
          content: '<p> Eso no es todo, pues con el objetivo de ofrecer soluciones para que individuos y empresas puedan comprar, vender, anunciar, enviar y pagar por bienes y servicios en Internet, la compañía cuenta con un ecosistema completo, que busca ofrecer la mejor experiencia de compra. Así, cuentan con <strong>Mercado Pago</strong> la solución de pagos de este marketplace para las empresas, emprendimientos o individuos que deseen vender en su propio sitio web, redes sociales, aplicaciones móviles o e-mails; y con <strong>Mercado Envíos</strong>, una solución integral para el envío de productos a todas partes de Chile.</p>',
          img: 'content/img0-01.jpg',
        },{
          id: 3,
          content: '<p>Si aún no conoces la experiencia de comprar en Mercado Libre, no dejes pasar la oportunidad y aprovecha su oferta total para este CyberMonday, que comenzará este 8 de octubre hasta el 10 del mismo mes, con descuentos de hasta un 60% en más de 15 mil productos, entre ellos, 50 opciones de auto y motos, y viviendas.</p>',
          url: 'https://www.mercadolibre.cl/?ref=especiales.latercera.com'
        }
      ]
    }]
  },
  mutations: {

  },
  actions: {

  },
  getters: {
    getContent: (state) => (id) => {
      const contentarr = state.content.filter(i => i.id === id)
      return contentarr[0]
    }
  }
})
